export const load = () => ({
	h1: 'Renovate Historic Buildings with Indow Inserts to Get Historic Tax Credits',
	title: 'Preserve & Restore Windows with Historic Tax Credit',
	description:
		'Use Indow inserts during your historic building renovation for a historic preservation tax credit. Read more about the credit and learn how Indow inserts can save money and time compared to window replacements.',
	showTitle: true,
});
